






















































import { Component, Prop, Vue } from "vue-property-decorator";
import { PartnerModule } from "@/store/modules/partner";
import { ThgCreateModule } from "@/store/modules/thg.create.store";

@Component({
  components: {}
})
export default class ThgDialogYearSelection extends Vue {
  @Prop()
  possibleYears!: number[];

  selection: boolean[] = [];

  mounted() {
    for (let i = 1; i <= this.possibleYears.length; i++) {
      this.selection.push(true);
    }
  }

  get partnerSettings() {
    return PartnerModule.partner.settings;
  }

  get selectedYears() {
    return ThgCreateModule.years;
  }

  set selectedYears(years: number[]) {
    ThgCreateModule.setYears(years);
  }

  get numberplate() {
    return ThgCreateModule.numberplate;
  }

  getIsSelected(year: number) {
    return ThgCreateModule.years.includes(year);
  }

  toggleYear(year: number) {
    const index = this.selectedYears.findIndex(y => y == year);

    if (index === -1) {
      this.selectedYears = [...this.selectedYears, year];
    } else {
      this.selectedYears.splice(index, 1);
    }
  }
}
